import type { FaireProductEntity } from "../../entity_types/product";

export const p_hanuey275s: FaireProductEntity = {
  token: "p_hanuey275s",
  type: "product",
  name: "Women’s Long Open Front Oversized Knit Cardigan_CWOCAL533",
  brandToken: "b_3eopd3scey",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/1b4905b24f5ec0bbcb88d8410365931e434de3b9eba7d2fb421700742e3f7be1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9e4864f41b0c2883ae8f8f5f3c8659f0c7eef8e832a77d58828f5a1e592eb1fe.jpeg",
    "https://cdn.faire.com/fastly/2c7d64399dcd8c399e0da1f9182e4ec4d5819e19316f6b5fa2fa66df00db56a3.jpeg",
    "https://cdn.faire.com/fastly/b927ebc86e856fad768ef32a05b2cdadd0a71849058a13309f893888929b88a9.jpeg",
    "https://cdn.faire.com/fastly/1f383bf0cb723c67c35f386550aa7a9f8bc79b7a4b6c51fe846b222048f66e9f.png",
    "https://cdn.faire.com/fastly/f938bfd7b238b8257976f47e418c030ea5af6de467214c3c836e7b460f7f0ed2.jpeg",
    "https://cdn.faire.com/fastly/314e3bea1fda6aa3726eece6aaca70561a362cf63a86c96b1c2eb46731cfa520.jpeg",
    "https://cdn.faire.com/fastly/668e53325580381a6f4693f41e1d17fb9e950024967a95be5d5ef6c6e084d55c.jpeg",
    "https://cdn.faire.com/fastly/1b0bc21695b986b2974303f5625c42019c9e4f4af663eafd39649de1921c70d5.jpeg",
    "https://cdn.faire.com/fastly/c2c0a3c568a43668811eff6d1400c55f4442d87ac6ae7a12d3c22fd0366f29c3.jpeg",
    "https://cdn.faire.com/fastly/cbfb240161b90b140c93983539c1bfce21c9f0e66058b9e0eb25b814cfa184de.jpeg",
    "https://cdn.faire.com/fastly/44966a59c9ac97539534a6981c745b5cb41873b2efc52568b879617783674ba9.jpeg",
    "https://cdn.faire.com/fastly/90611e5dba4f844602a638220dc0771576b0d2fb2b9cef3fbb2449e611c8c289.jpeg",
    "https://cdn.faire.com/fastly/6c262024df0e2c639786d957c0e9a02c4a58f99b28bfcda1cbaa6756eb68f8d5.jpeg",
    "https://cdn.faire.com/fastly/d503e5079220d4eff9ac40fab5c33852a892892dddc301feed6010c238672cdf.jpeg",
    "https://cdn.faire.com/fastly/8202390c99a76c923b27dc673a78e7db4de431934f26e14a0e8e6400924b9882.jpeg",
    "https://cdn.faire.com/fastly/a3753e1e7d1b0e90b9fc290a7b982d17a08cf5a136c7d71aec8b3712c6b222de.jpeg",
    "https://cdn.faire.com/fastly/426e1ba4a54f20ab3d4ecfbc4a73459a28f76a163d137f8c97f43a9c22b99a90.jpeg",
    "https://cdn.faire.com/fastly/385e1b60eb7ac0c59336704ddbb917e50713f31b08b0e574da02116410bc73d5.jpeg",
    "https://cdn.faire.com/fastly/d4dce6519fde55acaa009136db5c70deb24ae9b36b87fe1abc993cce3be34084.jpeg",
    "https://cdn.faire.com/fastly/ade60d84f0e050890a40b0b065fbc567c4b95ee2e70c168a99031e9bd5ea37ad.jpeg",
  ],
  priceDollars: 14.9,
  description:
    "76%RAYON.  20%POLYESTER. 4%SPANDEX\nSIZE  S / M / L / XL\nMADE IN CHINA\n\nWOMEN BLAZER, CROCHET CARDIGAN, CABLE KNIT SWEATER, RUFFLE DRESS, EYELET BLOUSE, PUFF SLEEVE TOP, DENIM SKIRTS, DENIM SHORTS, RIPPED JAENS, RIPPED JEANS, MAXI SKIRT, JUMPSUIT, CROP TOP, SHORT SLEEVE, SHOLESALE SHIRTS, PLAIS SHIRT, WOMEN SHORTS, PANTS, BOHEMIAN, BOHO, WINTER BLOUSE, WINTER SHIRT, WESTERN, BEST SELLING, PROMOTION, TRENDING, NEW PRODUCTS, ACTIVEWEAR, COSTUMES, UNIFORMS, JUMPSUITS, LOUNGEWEAR, SLEEPWEAR NIGHTWEAR, SWEATSHIRTS, HOODIES, TANK TOPS, CHRISTMAS, HOT SELLING ",
  tags: [],
  msrpDollars: 29.79,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:47.917Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
